export const surveyEndPoint = `survey-analytics/questionnaire`;
export const nicheEndPoint = `cohorts`;
export const visibilityEndPoint = `visibility`;
